export default __webpack_public_path__ + "static/Georg.01-bb430b825b1a4e6af8011a89db657387.jpg";